import { render } from "./PortContent.vue?vue&type=template&id=5a830c80&scoped=true"
import script from "./PortContent.vue?vue&type=script&lang=js"
export * from "./PortContent.vue?vue&type=script&lang=js"

import "./PortContent.vue?vue&type=style&index=0&id=5a830c80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a830c80"]])

export default __exports__